import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";
import HeaderPhoto from "../../assets/images/native_plants.jpg";
import Overview from "./Overview";
import IllustratedGlossary from "./IllustratedGlossary";
import SpeakingEngagement from "./SpeakingEngagement";
import Poster from "./Poster";
import Genera from "./Genera";
import FQAs from "./FQAs";

const Education = () => {
  return (
    <Box>
      <PageHeader
        image={HeaderPhoto}
        title="Educational Services and Products"
      />

      <Overview />
      <IllustratedGlossary />
      <SpeakingEngagement />
      <Poster />
      <Genera />
      <FQAs />
    </Box>
  );
};

export default Education;
